import React, { useEffect } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { RadioButton } from '../../../components/RadioButton'
import { TextInputComponent } from '../../../components/TextInputComponent'
import { useValuesFinalForm } from '../hooks/useValuesFinalForm'
import { useForm } from '../../../hooks/useForm'

const OPTIONS = ['CECO', 'Código de apertura']

interface Props {
  ceco: string | null
  observation: string | null
  getValues?: (values: { ceco: string; observation: string }) => void
}
export const DeclareFailure = ({ observation, getValues, ceco }: Props) => {
  const { values, onChangeValues } = useForm({
    ceco: 'CECO',
    observation: '',
  })

  const { MAX_CHARACTERS, MIN_CHARACTERS } = useValuesFinalForm({})

  const changeObservation = (value: string) => {
    if (value.length > MAX_CHARACTERS) return

    onChangeValues({ name: 'observation', value })
  }

  const changeCECO = (value: string) => onChangeValues({ name: 'ceco', value })

  const validateAlertMinCaracter = (): boolean => {
    return values.observation.length < MIN_CHARACTERS && values.observation.length !== 0
  }

  useEffect(() => {
    if (getValues) {
      getValues(values)
    }
  }, [values])

  // resetear los valores cuando el padre cambia de centro
  useEffect(() => {
    onChangeValues({ name: 'ceco', value: ceco ?? 'CECO' })
    onChangeValues({ name: 'observation', value: observation ?? '' })
  }, [ceco, observation])

  return (
    <View style={{ flex: 1, padding: 24, gap: 8 }}>
      <RadioButton onSelect={changeCECO} options={OPTIONS} selected={values.ceco} />
      <View style={{ marginTop: 8 }}>
        <TextInputComponent
          label='Observaciones del centro'
          multiline
          value={values.observation}
          customStyles={{
            input: validateAlertMinCaracter()
              ? { height: 200, textAlignVertical: 'top', borderColor: 'red' }
              : { height: 200, textAlignVertical: 'top' },
          }}
          onChange={changeObservation}
        />
        <View style={styles.containerText}>
          {validateAlertMinCaracter() && (
            <Text style={styles.minCaracter}>Mínimo 15 caracteres</Text>
          )}
          <Text
            style={styles.characterCount}
          >{`${values.observation.length}/${MAX_CHARACTERS}`}</Text>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  characterCount: {
    marginTop: 5,
    color: 'gray',
  },
  minCaracter: {
    marginTop: 5,
    color: 'red',
  },

  containerText: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})
